export enum TerminationType {
    Date = 0,
    CUT = 1,
}
